// extracted by mini-css-extract-plugin
export default {"root":"Login_root__tkOpq"};